import React, { Component } from 'react';

import { AreaChart, Area, XAxis, YAxis, Tooltip} from 'recharts';

import Grid from '@material-ui/core/Grid';
import GenericTooltip from './../GenericTooltip';
import {colors} from '../../../../constants//icons/characteristics/Characteristics';

import ChartMenu from './../ChartMenu/ChartMenu'
// import CustomTooltip from './DoughnutTooltip';



class AreaComponent extends Component { 
    
    getData = () => {
        const {data} = this.props;
        let resp = [];
        for(let i=0;i<data.length;i++){
            if(data[i] !== 0){
                let temp = {
                    name:i.toString(),
                    val:data[i]
                }
                resp.push(temp);
            }
        }
        return resp;
    }

    getTotal = () => {
        const {data} = this.props;
        let resp = 0;
        for(let i=0;i<data.length;i++){
            resp += data[i];
        }
        return <p style={{fontWeight: 'bold'}}>{'Total: ' + resp} </p>;
    }

    onClick = (uno,dos) =>{
        const {data} = this.props;
        try{
            this.props.onClickGraphic(this.props.name,{name:parseInt(uno.activeLabel), id:data[uno.activeTooltipIndex].id});
        }catch(e){}
    }
    

    render (){
        return (
            <Grid style={{flexWrap:"inherit",margin:'auto'}} id={this.props.name}   >
                <ChartMenu graph={this.props.name} file={this.props.title} 
                openDialog={this.props.openDialog} title={this.props.title}  watch={this.props.watchMenu} 
                seeMore={this.props.seeMore} />
                <Grid container>
                    <Grid item xs={9} className="graphic-margin-top">
                        {
                            <AreaChart data={this.getData()} width={400} height={250}
                                margin={{top: 10, right: 30, left: 0, bottom: 0}}
                                style={{margin:'auto'}}
                                onClick={this.onClick}>
                                <XAxis dataKey="name"/>
                                <YAxis allowDecimals={false}/>
                                <Tooltip content={
                                                <GenericTooltip
                                                    data={this.props.data}
                                                    colors={colors}
                                                />}
                                        />
                                <Area type='monotone' dataKey='val' stroke='#00629D' fill='#00629D' />                                
                            </AreaChart>                            
                        }
                    </Grid>
                    <Grid item xs={3}>
                        {this.getTotal()}
                    </Grid>
                </Grid>
            </Grid>
        )
    }    
}

export default AreaComponent; 